import { apiClient } from './client'

// Companion API v3 endpoints.

export interface SolarGuardState {
  enabled: boolean
}

function normalizeSolarGuard(data: unknown): SolarGuardState {
  const obj = (data ?? {}) as Record<string, unknown>
  const nested = (obj.result ?? obj.data ?? obj) as Record<string, unknown>
  return { enabled: Boolean(nested.enabled) }
}

export function getSolarGuard(
  addressUuid: string,
  signal?: AbortSignal
): Promise<SolarGuardState> {
  return apiClient
    .get('/v3/solar-guard', { params: { addressUuid }, signal })
    .then((res) => normalizeSolarGuard(res.data))
}

export function setSolarGuard(addressUuid: string, enabled: boolean): Promise<void> {
  return apiClient.post('/v3/solar-guard', { addressUuid, enabled }).then(() => undefined)
}
